import React from 'react'
import Layout from 'components/shared/Layout'
import Separator from 'components/shared/Separator'
import Link from 'components/shared/Link'
import { Title, Text } from 'components/typo'
import SmallArrow from 'src/components/icons/SmallArrow'
import css from './styles.module.scss'
import StoriesCardContent from 'components/shared/CardWithArrowLink/StoriesCardContent'
import CardsGrid from 'src/components/shared/CardsGrid'

import { CardWithArrowLinkProps } from 'components/shared/CardWithArrowLink'

const RelatedCaseStudies = ({ buttonText, title, cards }) => {
  const customCardProps = CardWithArrowLinkProps.customCardProps
  const theme = 'green'

  return (
    <Layout type="maxWidth" className={css.RelatedCaseStudies}>
      <Layout type="wrapper">
        <div className={css.head}>
          <Title size="big">{title}</Title>
          <Link
            className={css.link}
            href='/user-stories'
          >
            <Text className={css.linkText} theme={theme}>
              {buttonText}
            </Text>
            <SmallArrow className={css.arrow} theme={theme} />
          </Link>
        </div>
        <Separator className={css.separator} />
        {cards && (
          <CardsGrid
            cards={cards}
            linkText="READ CASE STUDY"
            bottomLink
            customCardComponent={StoriesCardContent}
            customCardProps={{
              ...customCardProps,
              isList: false,
            }}
          />
        )}
      </Layout>
    </Layout>
  )
}

export default RelatedCaseStudies
